import { OperadorLogico } from "@shared/enums/OperadorLogico";

export class Filtro {
    clave: string;
    operadoresPosibles: OperadorLogico[];
    valoresPosibles: string[];
}